import React, { useContext, useState } from 'react';
import { ProgramViewContext } from 'contexts';
import { date, dateAdd } from 'core/utils/formatters';
import ModalClassTypeWorkouts from './ModalClassTypeWorkouts';
import WeekDayViewSection from './WeekDayViewSection';

const WeekDayView = ({ index, sectionOpened }) => {
  const { weekView, calendarInfo } = useContext(ProgramViewContext);
  const [modalClasses, setModalClasses] = useState({ open: false });
  const day = date(dateAdd(calendarInfo?.start, index, 'days'), 'YYYY/MM/DD');
  const dayData = weekView ? weekView[day] : {};

  const classesTypes = Object.keys(dayData?.classesTypes || {});

  return (
    <>
      {classesTypes?.map((cType, idx) => {
        const classTypeData = dayData?.classesTypes[cType];

        return (
          <WeekDayViewSection
            cType={cType}
            classTypeData={classTypeData}
            index={idx}
            day={day}
            sectionOpened={sectionOpened}
            setModalClasses={setModalClasses}
          />
        );
      })}

      <ModalClassTypeWorkouts
        open={modalClasses?.open}
        workouts={modalClasses?.workouts}
        close={() => setModalClasses({ open: false })}
      />
    </>
  );
};

WeekDayView.propTypes = {};

WeekDayView.defaultProps = {
  close: () => {},
};

export default WeekDayView;
